<template>
    <div class="min-h-screen bg-base-100 text-base-content">
        <slot />
    </div>
</template>

<script setup>
// 특별한 설정 없음
</script>

<style scoped>
/* 기본 레이아웃 스타일 필요 시 */
</style>